// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loader_Container__1C4p5","RouterLoaderAnimation":"Loader_RouterLoaderAnimation__2kIYG","Spinner":"Loader_Spinner__2791x","SpinnerEl":"Loader_SpinnerEl__23xdC"};